<template>
  <div id="app" v-loading="loading" :element-loading-text="$t('Loading... Please wait')">
    <router-view></router-view>

    <vue-progress-bar></vue-progress-bar>

    <!-- Shared components -->
    <Dialog></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog.vue';
import * as Browser from '@/services/browser';
import { transformTranslations } from '@/shared/transformers';
import { find } from 'lodash';

export default {
  name: 'app',

  components: {
    Dialog
  },

  computed: {
    loading() {
      return this.$store.state.app.loading;
    },

    translations() {
      return this.$store.state.translations;
    },

    user() {
      return this.$store.state.user.current;
    }
  },

  mounted() {
    this.handleLanguage();
  },

  methods: {
    handleLanguage() {
      const language = Browser.getLanguage();
      let lang = language.toLowerCase();

      if (this.user && this.user.locale) {
        lang = this.user.locale.slice(0, 2);
      }

      const translations = find(this.translations, { id: lang });

      if (translations) {
        this.$store.commit('SET_TRANSLATION', { locale: lang, message: translations.messages });
      } else {
        this.$store.dispatch('GET_TRANSLATION', lang).then(response => {
          const message = transformTranslations(response.data);

          this.$store.commit('SET_TRANSLATION', { locale: lang, message });
        });
      }
    }
  }
};
</script>
